import React, { useRef } from 'react';
import { X, QrCode, Download, Printer } from 'lucide-react';
import QRCode from 'react-qr-code';

export default function FeedbackQRModal({ branchId, onClose }) {
  const url = `${window.location.origin}/feedback/${branchId}`;
  const svgRef = useRef(null);

 const handleDownload = () => {
  const svg = svgRef.current?.querySelector('svg');
  if (!svg) return;

  const serialized = new XMLSerializer().serializeToString(svg);
  const svgBlob = new Blob([serialized], { type: 'image/svg+xml;charset=utf-8' });
  const svgUrl = URL.createObjectURL(svgBlob);

  const img = new Image();
  img.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = 512;
    canvas.height = 512;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, 512, 512);
    // White background
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    URL.revokeObjectURL(svgUrl);

    const link = document.createElement('a');
    link.download = `feedback-qr-${branchId}.png`;
    link.href = canvas.toDataURL('image/png');
    link.click();
  };

  img.src = svgUrl;
};

  const handlePrint = () => {
    const svg = svgRef.current?.querySelector('svg');
    if (!svg) return;
    const serialized = new XMLSerializer().serializeToString(svg);
    const encoded = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(serialized)));
    const w = window.open('', '_blank');
    w.document.write(`
      <html><head><title>Feedback QR Code</title>
      <style>
        body { margin: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 100vh; font-family: -apple-system, sans-serif; }
        img { width: 220px; height: 220px; }
        p { font-size: 12px; color: #999; margin-top: 12px; word-break: break-all; max-width: 260px; text-align: center; }
      </style></head>
      <body>
        <img src="${encoded}" />
        <p>${url}</p>
        <script>window.onload = () => { window.print(); window.close(); }<\/script>
      </body></html>
    `);
    w.document.close();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ background: 'rgba(0,0,0,0.4)' }}
      onClick={onClose}
    >
      <div
        className="relative bg-white rounded-xl shadow-xl border border-slate-200 w-full max-w-xs mx-4 p-5"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 p-1 rounded hover:bg-slate-100 transition-colors"
        >
          <X size={16} className="text-slate-400" />
        </button>

        <div className="flex items-center gap-2.5 mb-4">
          <div className="p-1.5 bg-rose-100 rounded-lg">
            <QrCode size={16} className="text-rose-500" />
          </div>
          <div>
            <h3 className="text-sm font-semibold text-slate-900">Feedback QR Code</h3>
            <p className="text-xs text-slate-500">Scan to open the feedback form</p>
          </div>
        </div>

        <div ref={svgRef} className="flex justify-center p-4 bg-slate-50 rounded-xl border border-slate-100 mb-3">
          <QRCode value={url} size={180} level="H" />
        </div>

        <p className="text-[10px] text-slate-400 font-mono break-all text-center mb-4 bg-slate-50 rounded-lg px-3 py-2">
          {url}
        </p>

        <div className="flex gap-2">
          <button
            onClick={handleDownload}
            className="flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-2 text-xs font-medium rounded-lg border border-slate-300 bg-white text-slate-700 hover:bg-slate-50 transition-colors"
          >
            <Download size={13} />
            Download
          </button>
          <button
            onClick={handlePrint}
            className="flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-2 text-xs font-medium rounded-lg bg-rose-500 text-white hover:bg-rose-600 transition-colors"
          >
            <Printer size={13} />
            Print
          </button>
        </div>
      </div>
    </div>
  );
}